/* eslint-disable no-unused-vars */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./Toolbar.scss";

export function Toolbar({
  className,
  /** @deprecated */
  left,
  center,
  /** @deprecated */
  right,
  ...rest
}) {
  return (
    <div
      className={classNames(
        styles.toolbar,
        "tw-flex",
        "lg:tw-justify-between",
        "tw-backdrop-blur-[5px]",
        "tw-bg-neutral/40",
        "tw-text-neutral-content",
        "tw-border-2",
        "tw-border-solid",
        "tw-border-neutral/90",
        "tw-rounded-full",
        "tw-items-center",
        "tw-w-fit",
        "tw-my-2",
        "tw-mx-auto",
        className
      )}
      {...rest}
    >
      <div className={classNames("tw-flex", "tw-items-center", "tw-gap-4", "md:tw-gap-6")}>{center}</div>
    </div>
  );
}

export function ToolbarMobile(props) {
  return <Toolbar {...props} />;
}

Toolbar.propTypes = {
  className: PropTypes.string,
  left: PropTypes.node,
  center: PropTypes.node,
  right: PropTypes.node,
  hideLeft: PropTypes.string,
  hideRight: PropTypes.string
};

ToolbarMobile.propTypes = {
  className: PropTypes.string,
  left: PropTypes.node,
  center: PropTypes.node,
  right: PropTypes.node,
  hideLeft: PropTypes.string,
  hideRight: PropTypes.string
};
